import React            from 'react';
import PropTypes        from 'prop-types';
import { Message }      from '../../common/message';
import { ModalWrapper } from '../modal-wrapper';

import * as S from './dropbox-modal.module.scss';

const DropBoxOffer = ({onClose, name, code}) => {

  const STORAGE_AMOUNT = React.useMemo(() => {
    const NAME = name.toLowerCase();
    if (NAME === 'dropbox') return 5;
    else if (NAME === 'dropboxamazon') return 15;
    else return 0;
  }, [name]);

  return (
    <ModalWrapper heading="Dropbox Offer" onClose={onClose}>
      <div className={S.modalBody}>
        <p className={S.description}>
          As a thank you for being a Quicken member, we&rsquo;re giving you free Dropbox space.
          Dropbox keeps your photos and documents in one place so you can access your stuff anywhere – on the web, on your computer, or on the go.
        </p>

        <p className={S.offer}>To Claim this offer</p>

        <ul className={S.list}>
          <li>
            Go to
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.dropbox.com/coupon"
            >www.dropbox.com/coupon</a>
          </li>
          <li>Use the dropbox code provided below</li>
          <li>Get your Free space!</li>
        </ul>

        <Message type="INFO" align="CENTER" messages={[
          `${STORAGE_AMOUNT}GB Dropbox Coupon Code`,
          code
        ]} />

        <button
          onClick={onClose}
          className={S.dbCloseBtn}
          type="button"
        >Close Window</button>
      </div>
    </ModalWrapper>
  );
};

DropBoxOffer.displayName = 'DropBoxOffer';
DropBoxOffer.propTypes   = {
  name:    PropTypes.string.isRequired,
  code:    PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export { DropBoxOffer };
